// Data access policies (row/column entitlements per data source). These ride
// the generic recipe CRUD (/api/data_access_policy) so every change is a Dolt
// commit, and the preview endpoint compiles a user's effective constraints.
import { fetchData } from '../fetchapi/fetchapi';

export async function listPolicies(dataSourceId) {
  const res = await fetchData(`data_access_policy${dataSourceId ? `?data_source_id=${dataSourceId}` : ''}`);
  return Array.isArray(res) ? res : (res?.data || []);
}

export async function createPolicy(policy) {
  return fetchData('data_access_policy', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(policy),
  });
}

export async function updatePolicy(id, patch) {
  return fetchData(`data_access_policy/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(patch),
  });
}

export async function deletePolicy(id) {
  return fetchData(`data_access_policy/${id}`, { method: 'DELETE' });
}

// Compile the effective constraints for a user in the current project.
export async function previewPolicies(email) {
  return fetchData(`access-policies/preview${email ? `?email=${encodeURIComponent(email)}` : ''}`);
}
